import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const SettingsOutlinedSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.5 12L16.25 19.3612H7.75L3.5 12L7.75 4.63878H16.25L20.5 12Z" stroke="currentColor" strokeWidth="0.85" />
        <circle cx="12" cy="12" r="3.5" stroke="currentColor" strokeWidth="0.85" />
    </svg>


)

const SettingsOutlinedIcon: React.FC<SvgIconProps> = (props) => <SvgIcon {...props}>{SettingsOutlinedSvg}</SvgIcon>

export default SettingsOutlinedIcon
